import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-membership-status',
  standalone: true,
  imports: [NgClass],
  templateUrl: './membership-status.component.html',
  styleUrl: './membership-status.component.css'
})
export class MembershipStatusComponent {
  @Input() membershipStatus: string = '';

  steps = [
    { key: 'Applied', label: 'Applied' },
    { key: 'ApplicationApproved', label: 'Upload Payment Proof' },
    // { key: 'PaymentRejected', label: 'Re-upload Payment Bill' },
    { key: 'PaymentUnderReview', label: 'Payment Under Review' },
    { key: 'Active', label: 'Active' }
  ];

  ngOnChanges() {
    console.log('Input changed:', this.membershipStatus);
  }

  get currentStepIndex(): number {
    if (!this.membershipStatus) return -1;

    if (this.membershipStatus === 'PaymentRejected') {
      return 1; // يرجع لمرحلة Upload Bill
    }

    return this.steps.findIndex(
      step => step.key === this.membershipStatus
    );
  }

}
